import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OrigamiHttpResponse, ServiceBase } from './base/service.base';
import { AcknowledgeServiceOptions, InvSiteRecipient } from '@app/ti-components/acknowledgement/acknowledgement.models';
import { ErrorCode } from '../constants/error-codes';

@Injectable()
export class AcknowledgeService extends ServiceBase {
  serviceUrl = 'AcknowledgmentService.svc';

  public createAcknowledge(
    body: AcknowledgeServiceOptions.Acknowledge,
    forceRequest?: boolean,
  ): Observable<OrigamiHttpResponse> {
    return this.origamiPost('/CreateAcknowledgment', body, null, null, forceRequest);
  }

  public acceptAcknowledgment(siteId: number, documentId: number, options?: any): Observable<OrigamiHttpResponse> {
    return this.origamiPost('/AcceptAcknowledgment', { siteId, documentId }, options, null, true);
  }

  public getAcknowledgment(
    siteId: number,
    documentIds: number | string,
    options?: any,
    silentErrorCodes?: ErrorCode[],
  ): Observable<OrigamiHttpResponse> {
    return this.origamiPost('/GetAcknowledgments', { siteId, documentIds }, options, silentErrorCodes, true).pipe(
      map((res) => {
        if (res.Result?.Acknowledgments) {
          const acknowledgments = (<AcknowledgeServiceOptions.AcknowledgmentResponse>res.Result).Acknowledgments.map(
            (acknowledgment) => {
              const data = {};
              for (const property in acknowledgment) {
                data[capitalizeFirstLetter(property)] = acknowledgment[property];
              }

              return data;
            },
          );

          res.Result = {
            Acknowledgments: acknowledgments,
            UserInfos: res.Result.UserInfos,
            InvestigativeSiteInfos: res.Result.InvestigativeSiteInfos,
          };
        }
        return res;
      }),
    );
  }

  public cancelAcknowledgmentAcknowledgment(
    siteId: number,
    acknowledgmentId: number,
    reason?: string,
    options?: any,
  ): Observable<OrigamiHttpResponse> {
    return this.origamiPost('/CancelAcknowledgment', { siteId, acknowledgmentId, reason }, options, null, true);
  }

  public updateAcknowledgment(
    siteId: number,
    acknowledgmentId: number,
    body: Omit<AcknowledgeServiceOptions.Acknowledge, 'investigativeSiteIds'>,
    options?: any,
  ): Observable<OrigamiHttpResponse> {
    return this.origamiPost('/UpdateAcknowledgment ', { siteId, acknowledgmentId, ...body }, options, null, true);
  }

  public sendReminders(
    data: {
      recipients: Pick<InvSiteRecipient, 'UserId' | 'InvestigativeSiteIds'>[];
      acknowledgmentId: number;
      documentIds: number[];
      siteId: number;
    },
    options?: any,
  ): Observable<OrigamiHttpResponse> {
    return this.origamiPost('/SendAcknowledgmentsRemindersEmails ', data, options, null, true);
  }
}

export function capitalizeFirstLetter(string: string): string {
  return string.charAt(0).toLowerCase() + string.slice(1);
}
